import WebServiceRequest from "../../Api/WebServiceRequest";

class MessageGetConversationRequest extends WebServiceRequest {
  constructor(context) {
    super(context);
  }
  setData(data) {
    super.setTag(
      "Message/GetUserConversationForAdmin?chatterUserId=" +
        data.userId +
        "&mainFlatId=" +
        data.mainFlatId +
        "&count=" +
        data.count
    );
  }
}
export default MessageGetConversationRequest;
